import { useRef } from 'react'

/**
 * @function
 * @description Runs before all other code if you put it first and only runs once.
 * Functions just like the react class component constructor.
 * @param {Function} onConstructor Function to run before all other code
 * @returns {void}
 */
const useConstructor = onConstructor => {
  // Don't use useState because changing state causes a render.
  const called = useRef(false)
  if (called.current) {
    return
  }
  called.current = true
  onConstructor()
}

export default useConstructor